// RoomTypeDetails.js

import React, { useEffect, useState } from "react";
import { Card, CardBody, Badge } from "reactstrap";
import {
  FaBed,
  FaUsers,
  FaChild,
  FaUserFriends,
  FaEye,
  FaClock,
  FaCheckCircle,
  FaTimesCircle,
  FaCoffee,
  FaUndo,
  FaFileContract,
  FaCreditCard,
} from "react-icons/fa";

const RoomTypeDetails = ({ roomType }) => {
    const [activeImage, setActiveImage] = useState(0);


    useEffect(() => {
        setActiveImage(0);
    }, [roomType]);

    if (!roomType) {
        return (
            <Card className="shadow-sm border-0">
                <CardBody className="text-center py-5">
                    <h6 className="text-muted">
                        Select a Room Type
                    </h6>
                </CardBody>
            </Card>
        );
    }

    const images =
        roomType.images?.length > 0
            ? roomType.images
            : [
                "https://via.placeholder.com/800x450?text=No+Image+Available",
            ];

    const greyBadge = {
        background: "#f5f5f5",
        border: "1px solid #cbcbcb",
        color: "#282828",
        minWidth: "100px",
        padding: "6px",
        borderRadius: "5px",
        fontWeight: 600,
        fontSize: "12px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
    };

    const blueBadge = {
        background: "#fff",
        border: "1px solid #0d6efd",
        color: "#0d6efd",
        padding: "6px 12px",
        borderRadius: "5px",
        fontWeight: 500,
        fontSize: "12px",
    };

    const statCard = {
        background: "#f8f9fa",
        borderRadius: "12px",
        padding: "12px",
        textAlign: "center",
        border: "1px solid #e9ecef",
    };

    return (
        <Card
            className="shadow-sm border-0"
            style={{
                borderRadius: "8px",
                position: "sticky",
                top: "80px",
            }}
        >
            <CardBody>
                {/* =======================
            NAME + CODE
        ======================= */}

                <div className="mb-3">
                    <h6
                        className="fw-bold mb-2"
                        style={{ color: "#212529" }}
                    >
                        {roomType.name}
                    </h6>

                    <div className="d-flex align-items-center flex-wrap gap-2">
                        <span
                            className="text-muted"
                            style={{ fontSize: "13px" }}
                        >
                            Code : {roomType.code}
                        </span>

                        <Badge
                            className="status-badge"
                            style={{
                                color:
                                    roomType.status?.toUpperCase() === "ACTIVE"
                                        ? "#198754"
                                        : "#dc3545",
                                border:
                                    roomType.status?.toUpperCase() === "ACTIVE"
                                        ? "1px solid #198754"
                                        : "1px solid #dc3545",
                                fontSize: "12px",
                                padding: "6px 12px",
                                borderRadius: "20px",
                                fontWeight: 600,
                            }}
                        >
                            {roomType.status}
                        </Badge>
                    </div>
                </div>

                {/* =======================
            IMAGE CAROUSEL
        ======================= */}

                <div
                    style={{
                        position: "relative",
                        marginBottom: "20px",
                    }}
                >
                    <img
                        src={images[activeImage]}
                        alt="room"
                        style={{
                            width: "100%",
                            height: "140px",
                            objectFit: "cover",
                            borderRadius: "12px",
                        }}
                    />

                    {images.length > 1 && (
                        <>
                            <button
                                type="button"
                                onClick={() =>
                                    setActiveImage((prev) =>
                                        prev === 0
                                            ? images.length - 1
                                            : prev - 1
                                    )
                                }
                                style={{
                                    position: "absolute",
                                    left: 10,
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    border: "none",
                                    width: 36,
                                    height: 36,
                                    borderRadius: "50%",
                                    background: "rgba(0,0,0,.6)",
                                    color: "#fff",
                                }}
                            >
                                ‹
                            </button>

                            <button
                                type="button"
                                onClick={() =>
                                    setActiveImage((prev) =>
                                        prev === images.length - 1
                                            ? 0
                                            : prev + 1
                                    )
                                }
                                style={{
                                    position: "absolute",
                                    right: 10,
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    border: "none",
                                    width: 36,
                                    height: 36,
                                    borderRadius: "50%",
                                    background: "rgba(0,0,0,.6)",
                                    color: "#fff",
                                }}
                            >
                                ›
                            </button>
                        </>
                    )}
                </div>

                {/* =======================
            DESCRIPTION
        ======================= */}

                <div className="mb-3">
                    <h6 className="fw-semibold mb-3">
                        DESCRIPTION
                    </h6>
                    <p
                        className="text-muted mb-0"
                        style={{
                            fontSize: "13px",
                            lineHeight: "22px",
                        }}
                    >
                        {roomType.description || "N/A"}
                    </p>
                </div>

                {/* =======================
            OCCUPANCY
        ======================= */}

                <div className="mb-3">
                    <h6 className="fw-semibold mb-3">
                        OCCUPANCY
                    </h6>
                    <div className="row g-2">
                        <div className="col-4">
                            <div
                                style={{
                                    background: "#023047",
                                    borderRadius: "5px",
                                    padding: "6px",
                                    color: "#fff",
                                    textAlign: "center"
                                }}
                            >
                                <div
                                    style={{
                                        fontSize: "12px",

                                    }}
                                >
                                    Adults: <span className="fw-bold">{String(
                                        roomType.maxAdults || 0
                                    ).padStart(2, "0")}</span>
                                </div>
                            </div>
                        </div>

                        <div className="col-4" >
                            <div
                                style={{
                                    background: "#219ebc",
                                    borderRadius: "5px",
                                    padding: "6px",
                                    color: "#fff",
                                    textAlign: "center"

                                }}
                            >
                                <div
                                    style={{
                                        fontSize: "12px",

                                    }}
                                >
                                    Children: <span className="fw-bold">{String(
                                        roomType.maxChildren || 0
                                    ).padStart(2, "0")}</span>
                                </div>
                            </div>
                        </div>

                        <div className="col-4">
                            <div
                                style={{
                                    background: "#8ecae6",
                                    borderRadius: "5px",
                                    padding: "6px",
                                    color: "#fff",
                                    textAlign: "center"

                                }}
                            >
                                <div
                                    style={{
                                        fontSize: "12px",

                                    }}
                                >
                                    OCC: <span className="fw-bold"> {String(
                                        roomType.maxOccupancy || 0
                                    ).padStart(2, "0")}</span>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                {/* =======================
            BED TYPE / SIZE
        ======================= */}
                <div>
                    <h6 className="fw-semibold mb-3">
                        BED TYPE / SIZE
                    </h6>
                </div>
                <div className="mb-4 d-flex justify-content-center gap-3">

                    <div style={greyBadge}>
                        <FaBed />
                        {roomType.bedType}
                    </div>

                    <div style={greyBadge}>
                        {roomType.roomSize}{" "}
                        {roomType.roomSizeUnit}
                    </div>
                </div>

                {/* =======================
            AMENITIES
        ======================= */}

                <div className="mb-4">
                    <h6 className="fw-semibold mb-3">
                        AMENITIES
                    </h6>

                    <div className="d-flex flex-wrap justify-content-center gap-2">
                        {roomType.amenities?.length > 0 ? (
                            roomType.amenities.map(
                                (item, index) => (
                                    <span
                                        key={index}
                                        style={blueBadge}
                                    >
                                        {item}
                                    </span>
                                )
                            )
                        ) : (
                            <span className="text-muted">
                                No amenities added
                            </span>
                        )}
                    </div>
                </div>
                {/* =======================
            CHECK IN / OUT
        ======================= */}
                <div>
                    <h6 className="fw-semibold mb-3">
                        CHECK IN / OUT
                    </h6>
                </div>
                <div className="d-flex flex-wrap justify-content-center gap-2 mb-4">

                    <span style={greyBadge}>
                        <FaClock />
                        Check-In :
                        {roomType.checkInTime}
                    </span>

                    <span style={greyBadge}>
                        <FaClock />
                        Check-Out :
                        {roomType.checkOutTime}
                    </span>
                </div>

                {/* =======================
            VIEW / EXTRA BED
        ======================= */}
     <div>
                    <h6 className="fw-semibold mb-3">
                        VIEW / EXTRA BED
                    </h6>
                </div>

                
                <div className="d-flex justify-content-between align-items-center flex-wrap w-100 gap-10 mb-2">
                    <div>
                        <small className="text-muted">
                            <FaEye className="me-1" />
                            View
                        </small>

                        <div
                            className="fw-semibold mt-1"
                            style={{ fontSize: "13px" }}
                        >
                            {roomType.viewType || "-"}
                        </div>
                    </div>

                    <div>
                        <small className="text-muted">
                            Extra Bed
                        </small>

                        <div
                            className="fw-semibold mt-1"
                            style={{ fontSize: "13px" }}
                        >
                            {roomType.extraBedAllowed ? (
                                <span className="text-success">
                                    <FaCheckCircle /> Yes
                                </span>
                            ) : (
                                <span className="text-danger">
                                    <FaTimesCircle /> No
                                </span>
                            )}
                        </div>
                    </div>

                    <div>
                        <small className="text-muted">
                            Price
                        </small>

                        <div
                            className="fw-semibold mt-1"
                            style={{ fontSize: "13px" }}
                        >
                            ₹{roomType.extraBedPrice || 0}
                        </div>
                    </div>
                </div>

                {/* =======================
    BREAKFAST
======================= */}

<div className="mt-4">
  <h6 className="fw-semibold mb-3">
    <FaCoffee className="me-2" />
    BREAKFAST
  </h6>

  <div className="d-flex align-items-center justify-content-between">

    <span className="text-muted">
      Breakfast Included
    </span>

    {roomType.breakfastIncluded ? (
      <span className="text-success fw-semibold">
        <FaCheckCircle className="me-1" />
        Yes
        {roomType.breakfastType &&
          roomType.breakfastType !== "NONE" && (
            <small className="ms-2">
              ({roomType.breakfastType})
            </small>
          )}
      </span>
    ) : (
      <span className="text-danger fw-semibold">
        <FaTimesCircle className="me-1" />
        No
      </span>
    )}

  </div>
</div>


{/* =======================
    CANCELLATION POLICY
======================= */}

<div className="mt-4">
  <h6 className="fw-semibold mb-3">
    <FaUndo className="me-2" />
    CANCELLATION POLICY
  </h6>

  {roomType.freeCancellation ? (
    <div className="border rounded p-3">

      <div className="text-success fw-semibold mb-2">
        <FaCheckCircle className="me-1" />
        Free Cancellation Available
      </div>

      {roomType.freeCancellationHours > 0 && (
        <small className="text-muted d-block mb-2">
          Free cancellation allowed up to{" "}
          <strong>
            {roomType.freeCancellationHours} hours
          </strong>{" "}
          before check-in.
        </small>
      )}

      {roomType.cancellationPolicy && (
        <small className="text-muted">
          {roomType.cancellationPolicy}
        </small>
      )}

    </div>
  ) : (
    <div className="border rounded p-3">
      <span className="text-danger fw-semibold">
        <FaTimesCircle className="me-1" />
        Free Cancellation Not Available
      </span>

      {roomType.cancellationPolicy && (
        <small className="text-muted d-block mt-2">
          {roomType.cancellationPolicy}
        </small>
      )}
    </div>
  )}
</div>


{/* =======================
    TERMS & CONDITIONS
======================= */}

{roomType.termsAndConditions && (
  <div className="mt-4">

    <h6 className="fw-semibold mb-3">
      <FaFileContract className="me-2" />
      TERMS & CONDITIONS
    </h6>

    <div
      className="border rounded p-3 text-muted"
      style={{
        fontSize: "13px",
        lineHeight: "22px",
        whiteSpace: "pre-line",
      }}
    >
      {roomType.termsAndConditions}
    </div>

  </div>
)}


{/* =======================
    PAYMENT POLICY
======================= */}

{roomType.paymentPolicy && (
  <div className="mt-4">

    <h6 className="fw-semibold mb-3">
      <FaCreditCard className="me-2" />
      PAYMENT POLICY
    </h6>

    <div
      className="border rounded p-3 text-muted"
      style={{
        fontSize: "13px",
        lineHeight: "22px",
        whiteSpace: "pre-line",
      }}
    >
      {roomType.paymentPolicy}
    </div>

  </div>
)}
            </CardBody>
        </Card>
    );
};

export default RoomTypeDetails;